import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PlanWizard from "@/pages/PlanWizard";
import PlanView from "@/pages/PlanView";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AuthCallback from "@/pages/AuthCallback";
import ExampleReport from "@/pages/ExampleReport";
import SharedPlan from "@/pages/SharedPlan";
import Profile from "@/pages/Profile";
import PlanCongrats from "@/pages/PlanCongrats";
import IndustryExamples from "@/pages/IndustryExamples";
import AdminDashboard from "@/pages/AdminDashboard";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import CookieBanner from "@/components/CookieBanner";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback in URL fragment before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/eksempler" element={<IndustryExamples />} />
      <Route path="/eksempel" element={<ExampleReport />} />
      <Route path="/eksempel/:slug" element={<ExampleReport />} />
      <Route path="/vilkar" element={<Terms />} />
      <Route path="/personvern" element={<Privacy />} />
      <Route path="/delt/:token" element={<SharedPlan />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/plan/:id/wizard" element={<ProtectedRoute><PlanWizard /></ProtectedRoute>} />
      <Route path="/plan/:id/gratulerer" element={<ProtectedRoute><PlanCongrats /></ProtectedRoute>} />
      <Route path="/plan/:id" element={<ProtectedRoute><PlanView /></ProtectedRoute>} />
      <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <CookieBanner />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
